export enum ContactType {
  NotSet = 'NOT_SET',
  Redirect = 'REDIRECT',
  Callback = 'CALLBACK',
  Email = 'EMAIL',
}
